import { Injectable } from '@angular/core';
import {
  ReplacementVehicleRequest,
  RequestedNewVehicle
} from '../model/order.model';
import { RequestType } from '../model/requestType.enum';
import { DatePipe } from '@angular/common';
import { DeliveryLocation } from '../model/location.enum';
@Injectable({
  providedIn: 'root'
})
export class GenerateNewOrderObj {
  requestObj: any;
  replacementVehicle?: ReplacementVehicleRequest;
  newVehicleObj?: RequestedNewVehicle;

  constructor(private datePipe: DatePipe) {}
  parsePrice(price: string): number {
    return Number(price?.replace('€', '').replace(',', '.').trim());
  }

  mapNewVehicle(newVehicleRequest: any, isVip = false) {
    const optionals: any = [];
    const extensions: any = [];
    if (
      !isVip &&
      !!newVehicleRequest.optionalsCodes &&
      newVehicleRequest.optionalsCodes !== ''
    ) {
      newVehicleRequest.optionalsCodes
        .split(';')
        .forEach((value: string, index: number) => {
          optionals.push({
            code: value,
            description: !!newVehicleRequest.descriptionOptionalCodes[index]
              ? newVehicleRequest.descriptionOptionalCodes[index]
              : ''
          });
        });
    }
    if (
      !isVip &&
      !!newVehicleRequest.extensionsCodes &&
      newVehicleRequest.extensionsCodes !== ''
    ) {
      newVehicleRequest.extensionsCodes
        ?.split(';')
        .forEach((value: string, index: number) => {
          extensions.push({
            code: value,
            description: !!newVehicleRequest.descriptionExtensionsCodes[index]
              ? newVehicleRequest.descriptionExtensionsCodes[index]
              : ''
          });
        });
    }

    this.newVehicleObj = {
      configCode: newVehicleRequest.configCode,
      nationalSalesPlan: newVehicleRequest.country,
      modelYear: parseInt(newVehicleRequest.modelYear),
      model: newVehicleRequest.model,
      tmaimg: newVehicleRequest.tmaimg,
      optionals: !isVip
        ? optionals
        : !!newVehicleRequest.optionals
          ? newVehicleRequest.optionals
          : [],
      extensions: !isVip
        ? extensions
        : !!newVehicleRequest.extensions
          ? newVehicleRequest.extensions
          : [],
      optionalsCodes: !isVip
        ? newVehicleRequest.optionalsCodes?.toString().replaceAll(',', ';')
        : newVehicleRequest.optionalCodes,
      extensionsCodes: !isVip
        ? newVehicleRequest.extensionsCodes?.toString().replaceAll(',', ';')
        : newVehicleRequest.extensionsCodes,
      fuelType: newVehicleRequest.fuelType,
      emissions: newVehicleRequest.emissions,
      exteriorColor: {
        code: newVehicleRequest.extColor,
        description: newVehicleRequest.descExtColor
      },
      interiorColor: {
        code: newVehicleRequest.intColor,
        description: newVehicleRequest.descIntColor
      },
      prices: {
        fee: !isVip
          ? this.parsePrice(newVehicleRequest.prices?.fee)
          : newVehicleRequest.price,
        primaryRE: this.parsePrice(newVehicleRequest.prices?.firstRetribution),
        secondaryRE: this.parsePrice(
          newVehicleRequest.prices?.secondRetribution
        ),
        primaryEndowmentRE: this.parsePrice(
          newVehicleRequest.prices?.primaryEndowmentRE
        ),
        pvpTotal: !isVip
          ? newVehicleRequest.prices?.total
          : newVehicleRequest.price,
        basePrice: 0,
        pvpOptionals: !isVip
          ? newVehicleRequest.prices.pvpOptionals
          : newVehicleRequest.priceOptionals,
        leasingRE: newVehicleRequest.prices?.leasingRE
          ? newVehicleRequest.prices?.leasingRE
          : 0,
        referenceValue: newVehicleRequest.prices?.referenceValue
          ? this.parsePrice(newVehicleRequest.prices?.referenceValue)
          : null,
        retributionCalcPct: newVehicleRequest.prices?.retributionCalcPct
          ? newVehicleRequest.prices?.retributionCalcPct
          : null,
        profReductorEnd: newVehicleRequest.prices?.profReductorEnd
          ? newVehicleRequest.prices?.profReductorEnd
          : null,
        profReductorLea: newVehicleRequest.prices?.profReductorLea
          ? newVehicleRequest.prices?.profReductorLea
          : null
      }
    };
    return this.newVehicleObj;
  }

  generateOrderObj(
    userId: string,
    requestType: string,
    comments?: string,
    extraEmail?: string,
    extraPhone?: string,
    vehicleFinder?: any,
    requestInfoForm?: any,
    controller?: any,
    controllerAndDelegatedApprover?: any,
    vehicleInfoData?: any,
    replacementVehicle?: any,
    moreThanOneVehicle?: boolean,
    campaign?: any,
    retribution?: string,
    emailCheck?: boolean,
    leasing?: boolean,
    additionalDoc?: boolean,
    documentationInfo?: any
  ) {
    const type = RequestType;
    let newRequestData: any;
    const info = {
      comments: comments,
      extraEmail: extraEmail,
      extraPhone: extraPhone,
      controller:
        controllerAndDelegatedApprover.controller !== null
          ? controllerAndDelegatedApprover.controller
          : controller.controller,
      authorizer: controllerAndDelegatedApprover.delegatedApprover
    };
    switch (requestType) {
      case type.transfers:
        newRequestData = {
          vins: vehicleFinder.vins,
          requestInfo: requestInfoForm,
          controller: controller,
          comments: comments
        };
        break;
      case type.dotArr:
      case type.function:
        newRequestData = {
          ...info,
          requestInfo: requestInfoForm,
          vehicleInfo: vehicleInfoData,
          replacementVehicleInfo:
            replacementVehicle.replacementVehicleData !== ''
              ? replacementVehicle.replacementVehicleData
              : null,
          retribution: retribution
        };
        break;
      case type.campaigns:
        newRequestData = {
          orderInfo: {
            requestType: requestType,
            comments: comments,
            controllerUserId: null,
            delegatedApproverUserId: null
          },
          contactInfoDataDTO: {
            phoneNumber: extraPhone,
            email: extraEmail
          },
          campaignRequestData: {
            orderSubType: requestInfoForm.subtype,
            orderType: requestInfoForm.type,
            campaignId: campaign?.id,
            deliveryLocation: null,
            retribution: retribution,
            priorities: vehicleInfoData,
            replacedVehicle: replacementVehicle.replacementVehicleData.VIN
              ? {
                  estimatedKms:
                    replacementVehicle.replacementVehicleData.estimatedKms,
                  VIN: replacementVehicle.replacementVehicleData.VIN
                }
              : null
          }
        };
        break;
      case type.didactic:
        newRequestData = {
          ...info,
          ...vehicleInfoData
        };
        break;
      case type.generalServices: {
        let newVehicleData: any;
        let stockVehicleData: any;
        if (
          vehicleInfoData.type === 'newFabric' &&
          vehicleInfoData.configCode !== undefined
        ) {
          newVehicleData = {
            ...vehicleInfoData.data,
            configCode: vehicleInfoData.configCode
          };
        } else if (
          vehicleInfoData.type === 'newFabric' &&
          vehicleInfoData.configCode === undefined
        ) {
          stockVehicleData = { VIN: vehicleInfoData.data.VIN };
        } else if (vehicleInfoData.type === 'flota') {
          stockVehicleData = { models: vehicleInfoData.data };
        }
        newRequestData = {
          ...info,
          requestInfo: requestInfoForm,
          stockVehicle: !!stockVehicleData ? stockVehicleData : null,
          newVehicle: !!newVehicleData ? newVehicleData : null,
          replacementVehicleInfo:
            replacementVehicle.replacementVehicleData !== ''
              ? replacementVehicle.replacementVehicleData
              : null
        };
        break;
      }
      case type.judgements:
        newRequestData = {
          comments: comments,
          extraEmail: extraEmail,
          extraPhone: extraPhone,
          requestInfo: requestInfoForm,
          vin: vehicleFinder.vins[0]
        };
        break;
      case type.proyect:
        newRequestData = {
          orderInfoDTO: {
            requestType: requestType,
            comments: comments,
            controllerUserId:
              controllerAndDelegatedApprover.controller !== null
                ? controllerAndDelegatedApprover.controller.id
                : controller.controller.id,
            delegatedApproverUserId:
              controllerAndDelegatedApprover.delegatedApprover !== null
                ? controllerAndDelegatedApprover.delegatedApprover.id
                : null
          },
          contactInfoDataDTO: requestInfoForm.phone
            ? {
                phoneNumber: requestInfoForm.phone,
                email: requestInfoForm.email
              }
            : null,
          projectData: {
            department: requestInfoForm.departament,
            orderReference: requestInfoForm.reference,
            launch: requestInfoForm.launch,
            dealer: requestInfoForm.dealerCode,
            ceco: requestInfoForm.ceco,
            needDate: requestInfoForm.date,
            returnDate: requestInfoForm.returnDate,
            sop: requestInfoForm.sop ? requestInfoForm.sop : null,
            ea: requestInfoForm.ea,
            estimatedKms: requestInfoForm.kms,
            bnr: requestInfoForm.bnr,
            daisy: requestInfoForm.cops,
            vds: requestInfoForm.vds,
            newVehicle:
              requestInfoForm.subtype !== 'NEW_FABRICATION'
                ? null
                : {
                    finishes: requestInfoForm.finish,
                    nationalSalesPlan: requestInfoForm.country,
                    modelYear: requestInfoForm.my,
                    model: requestInfoForm.model,
                    tmaimg: requestInfoForm.tmaimg,
                    usePreview: requestInfoForm.use,
                    optionals: requestInfoForm.optionals,
                    prNumbers: requestInfoForm.prNumbers,
                    destinationCode: requestInfoForm.destination,
                    prEngine: requestInfoForm.prMotor,
                    engineDescription: requestInfoForm.descriptionEngine,
                    exteriorColor: requestInfoForm.exteriorColor,
                    interiorColor: requestInfoForm.interiorColor,
                    orderNumber: requestInfoForm.orderNumber,
                    thirdPartyTransfer: requestInfoForm.transferToThird
                  },
            stockVehicle:
              requestInfoForm.subtype === 'REGULARIZATION' &&
              requestInfoForm.stockVehicle
                ? {
                    VIN: requestInfoForm.vin,
                    model: null
                  }
                : null,
            regularitationVehicle:
              requestInfoForm.subtype === 'REGULARIZATION' &&
              !requestInfoForm.stockVehicle
                ? {
                    VIN: requestInfoForm.vin,
                    finishes: requestInfoForm.finish,
                    nationalSalesPlan: requestInfoForm.country,
                    modelYear: requestInfoForm.my,
                    model: requestInfoForm.model,
                    tmaimg: requestInfoForm.tmaimg,
                    usePreview: requestInfoForm.use,
                    optionals: requestInfoForm.optionals,
                    prNumbers: requestInfoForm.prNumbers,
                    destinationCode: requestInfoForm.destination,
                    prEngine: requestInfoForm.prMotor,
                    engineDescription: requestInfoForm.descriptionEngine,
                    exteriorColorDescription: requestInfoForm.color,
                    orderNumber: requestInfoForm.orderNumber
                  }
                : null,
            otherVehicle:
              requestInfoForm.subtype !== 'OTHERS'
                ? null
                : {
                    brand: requestInfoForm.brand,
                    model: requestInfoForm.model,
                    finishes: requestInfoForm.finishes,
                    engine: requestInfoForm.engine,
                    usePreview: requestInfoForm.usePreview,
                    estimatedCO2: requestInfoForm.emission,
                    destination: requestInfoForm.destination,
                    exteriorColorDescription: requestInfoForm.color
                  },
            licensePlateManagement:
              requestInfoForm.subtype !== 'OTHERS'
                ? {
                    management: requestInfoForm.registered
                      ? requestInfoForm.registered
                      : false
                  }
                : {
                    management: requestInfoForm.checkedManagement
                      ? requestInfoForm.checkedManagement
                      : false,
                    plateNumber: requestInfoForm.plateNumber,
                    registrationDate: requestInfoForm.plateNumberDate
                      ? requestInfoForm.plateNumberDate
                      : null,
                    townHallCode: requestInfoForm.townHallCode,
                    insuranceType: requestInfoForm.insuranceType,
                    deliveryDate: requestInfoForm.deliveryDate
                      ? requestInfoForm.deliveryDate
                      : null
                  },
            costs:
              requestInfoForm.subtype !== 'REGULARIZATION'
                ? {
                    especialType: requestInfoForm.specialType,
                    serieSubType: requestInfoForm.subtypeSeries,
                    pressSubType:
                      requestInfoForm.subtype !== 'OTHERS'
                        ? requestInfoForm.pressSubtype
                          ? requestInfoForm.pressSubtype
                          : 'SUBSTITUTION'
                        : null,
                    materialType: requestInfoForm.materialType,
                    preserieType:
                      requestInfoForm.subtype !== 'OTHERS'
                        ? requestInfoForm.preseriesType
                        : null,
                    projectType:
                      requestInfoForm.subtype !== 'OTHERS'
                        ? requestInfoForm.projectType
                        : null,
                    mlProject:
                      requestInfoForm.subtype !== 'OTHERS'
                        ? requestInfoForm.projectML
                        : null,
                    preserieCost:
                      requestInfoForm.subtype !== 'OTHERS'
                        ? requestInfoForm.preseriesCost
                        : null,
                    serieCost: requestInfoForm.seriesCost
                  }
                : null
          },
          projectSubType: requestInfoForm.subtype
        };
        break;
      case type.innerRoute:
        newRequestData = {
          ...info,
          orderSubtype: requestInfoForm.subtype,
          retribution: requestInfoForm.retribution,
          replacementVehicleInfo:
            replacementVehicle.replacementVehicleData !== ''
              ? replacementVehicle.replacementVehicleData
              : null,
          stockVehicle: vehicleInfoData
        };
        break;
      case type.es:
        newRequestData = {
          checkOutDate: requestInfoForm.checkOutDate,
          checkInDate: requestInfoForm.checkInDate,
          originCenterId: requestInfoForm.originCenterId,
          destinationCenterId: requestInfoForm.destinationCenterId,
          reason: requestInfoForm.reason,
          reasonObservations: requestInfoForm.reasonObservations,
          driver: {
            driverLicense: requestInfoForm.driverLicense,
            internalDriverId:
              requestInfoForm.driverType === 'INTERNAL'
                ? requestInfoForm.nis
                : null,
            externalDriverId:
              requestInfoForm.driverType !== 'INTERNAL'
                ? requestInfoForm.nis
                : null
          },
          stockVehicle: {
            vins: vehicleFinder.vins ? vehicleFinder.vins : null,
            redPlate: vehicleFinder.redPlate ? vehicleFinder.redPlate : null,
            truckPlateNumber: vehicleFinder.truckPlateNumber
              ? vehicleFinder.truckPlateNumber
              : null
          },
          observations: comments
        };
        break;
      case type.loan:
        if (requestInfoForm.loanType === 'Larga Duración') {
          newRequestData = {
            ...info,
            moreThanOneVehicle: moreThanOneVehicle,
            loanData: {
              loanOrderType: 'LONG_DURATION',
              longDurationData: {
                deliveryDateTime: requestInfoForm.deliveryDate,
                returnDateTime: requestInfoForm.returnDate,
                reason: requestInfoForm.reason,
                reasonText: requestInfoForm.reasonText
                  ? requestInfoForm.reasonText
                  : '',
                loanQuota: vehicleInfoData.quota,
                driverData: {
                  driverType: requestInfoForm.driverType,
                  internalDriverData: requestInfoForm.nis
                    ? { nis: requestInfoForm.nis }
                    : null,
                  externalDriverData: requestInfoForm.driverDNI
                    ? {
                        identificationDocument: requestInfoForm.driverDNI,
                        fullName: `${requestInfoForm.driverName} ${requestInfoForm.driverSurname}`,
                        phoneNumber: requestInfoForm.driverTelephone,
                        email: requestInfoForm.driverEmail
                      }
                    : null,
                  address: requestInfoForm.driverAddress
                    ? requestInfoForm.driverAddress
                    : null,
                  zipCode: requestInfoForm.driverPostalCode
                    ? requestInfoForm.driverPostalCode
                    : null,
                  city: requestInfoForm.driverCity
                    ? requestInfoForm.driverCity
                    : null,
                  driverLicense: requestInfoForm.driverLicense
                },
                stockVehicle: {
                  model: vehicleInfoData.model
                }
              }
            }
          };
        } else if (requestInfoForm.loanType === 'CarPool') {
          newRequestData = {
            ...info,
            loanData: {
              loanOrderType: 'CARPOOL',
              carPoolData: {
                deliveryDateTime: requestInfoForm.deliveryDateTime,
                returnDateTime: requestInfoForm.returnDateTime,
                reason: requestInfoForm.reason,
                reasonText: requestInfoForm.reasonText,
                loanQuota: vehicleInfoData.quota,
                carpoolCenter: requestInfoForm.center,
                driverData: {
                  driverType: requestInfoForm.driverType,
                  internalDriverData: requestInfoForm.nis
                    ? { nis: requestInfoForm.nis }
                    : null,
                  externalDriverData: null,
                  address: requestInfoForm.driverAddress
                    ? requestInfoForm.driverAddress
                    : null,
                  zipCode: requestInfoForm.driverPostalCode
                    ? requestInfoForm.driverPostalCode
                    : null,
                  city: requestInfoForm.driverCity
                    ? requestInfoForm.driverCity
                    : null,
                  driverLicense: requestInfoForm.driverLicense
                },
                stockVehicle: {
                  VIN: vehicleInfoData.VIN
                }
              }
            }
          };
        } else {
          newRequestData = {
            ...info,
            loanData: {
              loanOrderType: 'WEDDING',
              weddingsData: {
                deliveryDateTime: requestInfoForm.deliveryDate,
                returnDateTime: requestInfoForm.returnDate,
                loanQuota: vehicleInfoData.quota,
                spouseUserId: requestInfoForm.spouseUserId,
                driverData: {
                  driverType: requestInfoForm.driverType,
                  internalDriverData: requestInfoForm.nis
                    ? { nis: requestInfoForm.nis }
                    : null,
                  externalDriverData: requestInfoForm.driverDNI
                    ? {
                        identificationDocument: requestInfoForm.driverDNI,
                        fullName: `${requestInfoForm.driverName} ${requestInfoForm.driverSurname}`,
                        phoneNumber: requestInfoForm.driverTelephone,
                        email: requestInfoForm.driverEmail
                      }
                    : null,
                  address: requestInfoForm.address
                    ? requestInfoForm.address
                    : null,
                  zipCode: requestInfoForm.postalCode
                    ? requestInfoForm.postalCode
                    : null,
                  city: requestInfoForm.city ? requestInfoForm.city : null,
                  driverLicense: requestInfoForm.driverLicense
                },
                stockVehicle: {
                  model: vehicleInfoData.model,
                  VIN: vehicleInfoData.VIN
                }
              }
            }
          };
        }
        break;
      case 'bookVehicle':
        newRequestData = {
          comments: comments,
          requestInfo: requestInfoForm
        };
        break;
      case type.redPlates:
        const date = this.datePipe.transform(
          requestInfoForm.date,
          'yyyy-MM-dd'
        );

        newRequestData = {
          requirementDate: date,
          quantityOfPlates: requestInfoForm.numberPlates,
          quantityOfBulletines: requestInfoForm.numberAddBulletins,
          quantityOfTriplePlates: requestInfoForm.numberTriplePlates,
          areaSupervisorId: controllerAndDelegatedApprover.delegatedApprover.id,
          comments: comments
        };
        break;
      case type.leasing:
        const isStock =
          vehicleInfoData.data.VIN || vehicleInfoData.data.externalId;
        newRequestData = {
          orderInfo: {
            requestType: requestType,
            comments: comments,
            controllerUserId:
              controllerAndDelegatedApprover.controller !== null
                ? controllerAndDelegatedApprover.controller.id
                : controller.controller.id
          },
          contactInfoDataDTO: null,
          leasingData: {
            orderSubType:
              requestInfoForm.subtype === 'SUBSTITUTION'
                ? 'SUBSTITUTION'
                : 'FIRST_ASSIGNMENT',
            replacedVehicle: replacementVehicle.replacementVehicleData
              ? replacementVehicle.replacementVehicleData
              : null,
            stockVehicle: vehicleInfoData.data.VIN
              ? {
                  VIN: vehicleInfoData.data.VIN
                }
              : vehicleInfoData.data.externalId
                ? { externalId: vehicleInfoData.data.externalId }
                : null,
            newVehicle: isStock
              ? null
              : this.mapNewVehicle(vehicleInfoData.data),
            deliveryLocation: requestInfoForm?.deliveryLocationChecked
              ? DeliveryLocation.MARTORELL
              : undefined,
            checkMartorell: requestInfoForm?.checkMartorell,
            terms: {
              email: emailCheck,
              leasing: leasing,
              additionalDoc: additionalDoc
            },
            tempId: documentationInfo.tempId
          }
        };
        break;
      case type.vo:
        newRequestData = {
          vehicles: {
            requestType: requestType,
            userId: userId,
            model: vehicleInfoData.data.model,
            plateNumber: vehicleInfoData.data.plateNumber,
            VIN: vehicleInfoData.data.VIN,
            plateRegistrationDate: vehicleInfoData.data.plateRegistrationDate,
            exteriorColor: vehicleInfoData.data.exteriorColor,
            engine: vehicleInfoData.data.engine,
            transmission: vehicleInfoData.data.transmission,
            fuelType: vehicleInfoData.data.fuelType,
            vehicleGroups: {
              prices: {
                priceVN: vehicleInfoData.data.vehicleGroups[0].prices.priceVN,
                priceVO: vehicleInfoData.data.vehicleGroups[0].prices.priceVO,
                discount: vehicleInfoData.data.vehicleGroups[0].prices.discount
              },
              image: vehicleInfoData.data.vehicleGroups[0].image,
              kms: vehicleInfoData.data.vehicleGroups[0].kms,
              bookingsVo: vehicleInfoData.data.vehicleGroups[0].bookingsVo
            }
          }
        };
        break;
      default:
        '';
    }
    return newRequestData;
  }
}
